import { authHeader, multipartHeader } from "./auth-header";
import axiosInstance from "./axiosInstance"

const getAll = (params) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + "ad/list", {
    headers: authHeader(),
    data: {},
    params,
    withCredentials: true,
  });
};

const get = (id) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + `ad/view/${id}`, {
    headers: authHeader(),
    data: {},
    withCredentials: true,
  });
};

const create = (data) => {
  return axiosInstance.Auth.post(process.env.REACT_APP_API_URL + `ad/create`, data, {
    headers: multipartHeader(),
    withCredentials: true,
  });
};

const update = (id, data) => {

  return axiosInstance.Auth.put(process.env.REACT_APP_API_URL + `ad/update/${id}`, data, {
    headers: multipartHeader(),
    withCredentials: true,
  });
};

const deleteGame = (id, data) => {
  return axiosInstance.Auth.delete(process.env.REACT_APP_API_URL + `ad/delete/${id}`, {
    headers: authHeader(),
    data: data,
    withCredentials: true,
  });
};

const restore = (id, data) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + `ad/restore/${id}`, {
    headers: authHeader(),
    data: data,
    withCredentials: true,
  });
};

const uploadadImage = (formImage) => {
  return axiosInstance.Auth.post(process.env.REACT_APP_API_URL + `adImage/upload`, formImage, {
    headers: multipartHeader(),
    withCredentials: true,
  })
}

const uploadTradeItemPic = (formImage) => {
  return axiosInstance.Auth.post(process.env.REACT_APP_API_URL + `tradeImage/upload`, formImage, {
    headers: multipartHeader(),
    withCredentials: true,
  })
}

const getSoldOrders = (id) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + `ad/listSoldOrder/${id}`, {
    headers: authHeader(),
    data: {},
    withCredentials: true,
  });
};

export default {
  getAll,
  get,
  create,
  update,
  deleteGame,
  restore,
  uploadadImage,
  uploadTradeItemPic,
  getSoldOrders
};
